import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonicModule, IonModal, ModalController } from '@ionic/angular';
import { Match } from '../../models/match.model';
import { ClockName } from '../../models/enums/clock-name.enum';
import { Clock } from '../../models/clock.model';
import { StopwatchModule } from '../stopwatch/stopwatch.module';
import { StopwatchComponent } from '../stopwatch/stopwatch.component';
import { BreakClockService } from './break-clock.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-break-clock',
  templateUrl: './break-clock.component.html',
  styleUrls: ['./break-clock.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, StopwatchModule, TranslateModule],
})
export class BreakClockComponent implements OnInit, OnDestroy {
  private readonly breakClockService = inject(BreakClockService);
  private readonly destroy$ = new Subject<void>();
  private timeoutRef: any;

  @Input({ required: true }) match: Match;
  @ViewChild('setBreakClock') setBreakClock: StopwatchComponent | undefined;
  @ViewChild('customModal', { static: false }) customModal: IonModal | undefined;
  public readonly clockName: typeof ClockName = ClockName;

  constructor(private readonly modalController: ModalController,) { }

  ngOnInit() {
     this.subscribeToBreakClock();
  }

  ngAfterViewInit() {
    this.startBreack();
  }

  private subscribeToBreakClock() {
    this.breakClockService.subscribeBreakObs()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.openModal();
      });
  }

  private openModal() {
    this.customModal?.present();
  }

  async endBreak(): Promise<void> {
    await this.dismissAllModals({ breakEnd: true });
    await this.setBreakClock?.clearClock();
  }

  async undoBreak(): Promise<void> {
    await this.dismissAllModals({ breakUndo: true });
    await this.setBreakClock?.clearClock();
  }

  async dismissModal(): Promise<void> {
    await this.dismissAllModals({ closeModal: true });
    await this.setBreakClock?.clearClock();
  }

  private async dismissAllModals(data?: any): Promise<void> {
    let topModal = await this.modalController.getTop();
    while (topModal) {
      await this.modalController.dismiss(data);
      topModal = await this.modalController.getTop();
    }
  }

  async startBreack() {
    await this.setBreakClock?.startClock();
    const breakClock = this.getClock(this.clockName.SET_BREAK); 

    if (breakClock && breakClock.value > 1) {
        this.timeoutRef = setTimeout(() => {
            this.endBreak();
        }, breakClock.value + 1000);
      }
  }

  getClock(clockName: ClockName): Clock | undefined {
    return this.match?.clocks.find((c) => c.name === clockName);
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutRef);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
